import {
  ChevronLeft,
  ChevronRight,
  Trash,
  XCircle,
  ArrowUpAZ,
  ArrowDownZA,
  ArrowDown10,
  ArrowUp10,
  CheckCircle,
  Download,
  Layout,
  Pencil,
  Check,
  MoveLeft,
  CircleX,
  ArrowUpDown,
  CalendarClock,
  FileText,
  Search,
  SlidersHorizontal,
  X,
  ChevronDown,
} from "lucide-react";
import { toast } from "react-toastify";
import axios from "axios";
import host from "../../global";
import Cookies from "js-cookie";
import { useEffect, useRef, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../Loader";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
} from "@mui/material";
import { Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlatformCalendar from "../shared_components/platformCalendar";
import "../../css/CandidateReports.css";
import "../../css/platformCalendar.css";
import { calendarOverrideStyles } from "../shared_components/datePickerStyles";
import * as XLSX from "xlsx";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ConfirmationDialog from "../shared_components/ConfirmationDialog";
import { useTheme } from "../../hooks/useTheme";
import { useSelector } from "react-redux";

const SourcedCandidates = ({ sourcedJobId, sourcedJobRole }) => {
  const accessToken = Cookies.get("accessToken");
  const location = useLocation();
  const navigate = useNavigate();
  const portal = location.pathname.startsWith("/hr") ? "hr" : "org-admin";
  let jobId = location.state?.jd_id || sourcedJobId;
  let jobRole =
    location.state?.jobrole || location.state?.job_role || sourcedJobRole;
  const [candidates, setCandidates] = useState([]);
  const [shortlisted, setShortlisted] = useState([]);
  const [retrofit, setRetrofit] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectedShortlistedCandidates, setSelectedShortlistedCandidates] =
    useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("shortlisted");
  const [resumeScoreThreshold, setResumeScoreThreshold] = useState(60);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentReport, setCurrentReport] = useState(null);
  const [selectAllCandidates, setSelectAllCandidates] = useState(false);
  const [selectAllShortlisted, setSelectAllShortlisted] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isSchedulePopup, setIsSchedulePopup] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [bulkSchedulingProgress, setBulkSchedulingProgress] = useState({
    isActive: false,
    completed: 0,
    total: 0,
    currentCandidate: "",
    status: "",
  });
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [editingCandidateId, setEditingCandidateId] = useState(null);
  const [newEmail, setNewEmail] = useState("");
  const [currentCandidate, setCurrentCandidate] = useState(null);

  // Search and Filter states
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [tempSelectedSource, setTempSelectedSource] = useState("All");
  const [selectedSource, setSelectedSource] = useState("All");
  const [filterDateRange, setFilterDateRange] = useState([null, null]);
  const [tempFilterDateRange, setTempFilterDateRange] = useState([null, null]);
  const [selectedStyle, setSelectedStyle] = useState("");
  const sortDropdownRef = useRef(null);
  const filterRef = useRef(null);
  const calendarRef = useRef(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [customAtsFormEnabled, setCustomAtsFormEnabled] = useState(false);
  const [additionalInfoPage, setAdditionalInfoPage] = useState(0);
  
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const stored = localStorage.getItem("sourcedCandidatesVisibleColumns");
    return stored ? JSON.parse(stored) : {
      source: true,
      noticePeriod: true,
      appliedDate: true,
      gender: true,
      currentCTC: true
    };
  });
  const [isColumnFilterOpen, setIsColumnFilterOpen] = useState(false);
  const columnFilterRef = useRef(null);
  const org_id = useSelector((state)=>state.userSlice.org_id);

  const columnWeights = {
    candidateName: 1.5,
    emailId: 1.8,
    contactNumber: 1.2,
    gender: 0.8,
    currentCTC: 0.9,
    source: 1.2,
    noticePeriod: 0.9,
    resumeScore: 1.1,
    appliedDate: 1.1
  };

  const getColumnWidth = (columnName) => {
    let totalWeight = columnWeights.candidateName + columnWeights.emailId + columnWeights.contactNumber + columnWeights.resumeScore;

    if (visibleColumns.source) totalWeight += columnWeights.source;
    if (visibleColumns.noticePeriod) totalWeight += columnWeights.noticePeriod;
    if (visibleColumns.appliedDate) totalWeight += columnWeights.appliedDate;

    if (customAtsFormEnabled) {
      if (visibleColumns.gender) totalWeight += columnWeights.gender;
      if (visibleColumns.currentCTC) totalWeight += columnWeights.currentCTC;
    }

    const weight = columnWeights[columnName];
    return `${((weight / totalWeight) * 100).toFixed(2)}%`;
  };

  const { theme } = useTheme();

  const handleColumnToggle = (column) => {
    setVisibleColumns((prev) => {
      const newColumns = { ...prev, [column]: !prev[column] };
      localStorage.setItem("sourcedCandidatesVisibleColumns", JSON.stringify(newColumns));
      return newColumns;
    });
  };

  const handleSelectAllColumns = () => {
    const allColumns = {
      source: true,
      noticePeriod: true,
      appliedDate: true,
      gender: true,
      currentCTC: true
    };
    setVisibleColumns(allColumns);
    localStorage.setItem("sourcedCandidatesVisibleColumns", JSON.stringify(allColumns));
  };

  // Categorize candidates based on score threshold (same logic as BulkActivity)
  const categorizeCandidates = (candidatesData, scoreThreshold) => {
    // Temporarily make email validation more lenient for debugging
    const isValidEmail = (email) => {
      // Accept any non-empty string for now to debug the real issue
      return email && typeof email === "string" && email.trim().length > 0;
    };

    const shortlistedCandidates = candidatesData.filter((c) => {
      const hasValidScore =
        c.score !== null && c.score !== undefined && !isNaN(c.score);
      const meetsThreshold = hasValidScore && c.score >= scoreThreshold;
      const hasValidEmail = isValidEmail(c.candidate_email);

      return meetsThreshold && hasValidEmail;
    });

    const retrofitCandidates = candidatesData.filter((c) => {
      const hasValidScore =
        c.score !== null && c.score !== undefined && !isNaN(c.score);
      const belowThreshold = hasValidScore && c.score < scoreThreshold;
      const hasValidEmail = isValidEmail(c.candidate_email);

      return belowThreshold && hasValidEmail;
    });

    return { shortlistedCandidates, retrofitCandidates };
  };

  const selectableStyles = `
    /* Make every piece of text selectable */
    .selectable-report * {
      user-select: text !important;
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
    }
  `;

  // Handle tab changes (similar to BulkActivity)
  const handleTabChange = (tab) => {
    try {
      setActiveTab(tab);
      setCurrentPage(1);
      setSortColumn(null);
      setSortDirection(null);
      setSelectedCandidates([]);
      setSelectedShortlistedCandidates([]);
    } catch (error) {
      console.error("Error in handleTabChange:", error);
    }
  };
  // Fetch admin configuration for score threshold (same as BulkActivity)
  useEffect(() => {
    const fetchConfiguration = async () => {
      try {
        const response = await axios.get(`${host}/get_configurations`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setResumeScoreThreshold(response.data.resume_score_threshold || 60);
        setCustomAtsFormEnabled(response.data.custom_ats_form_questions === true);
      } catch (error) {
        console.error("Error fetching configuration:", error);
        // Keep default threshold of 60 if config fails to load
        setResumeScoreThreshold(60);
        setCustomAtsFormEnabled(false);
      }
    };

    if (accessToken) {
      fetchConfiguration();
    }
  }, [accessToken]);

  // Categorize candidates when both candidates and threshold are available
  useEffect(() => {
    if (candidates.length > 0 && resumeScoreThreshold > 0) {
      try {
        const { shortlistedCandidates, retrofitCandidates } =
          categorizeCandidates(candidates, resumeScoreThreshold);

        setShortlisted(shortlistedCandidates);
        setRetrofit(retrofitCandidates);
      } catch (error) {
        setShortlisted([]);
        setRetrofit([]);
      }
    } else {
      setShortlisted([]);
      setRetrofit([]);
    }
  }, [candidates, resumeScoreThreshold]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sortDropdownRef.current &&
        !sortDropdownRef.current.contains(event.target)
      ) {
        setIsSortOpen(false);
      }
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !calendarRef.current?.contains(event.target)
      ) {
        setShowFilterDropdown(false);
        setIsCalendarOpen(false);
      }
      if (columnFilterRef.current && !columnFilterRef.current.contains(event.target)) {
        setIsColumnFilterOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getCurrentData = () => {
    let filteredData;

    // Get data based on active tab
    switch (activeTab) {
      case "shortlisted":
        filteredData = shortlisted;
        break;
      case "retrofit":
        filteredData = retrofit;
        break;
      default:
        filteredData = [];
    }

    // Apply search filter
    if (searchQuery.trim()) {
      filteredData = filteredData.filter(
        (candidate) =>
          candidate.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          candidate.candidate_email
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase())
      );
    }

    // Apply source filter with robust matching
    if (selectedSource !== "All") {
      filteredData = filteredData.filter((candidate) => {
        // Get source from both possible fields
        const candidateSource =
          candidate.source_of_application || candidate.source;

        if (!candidateSource) return false;

        // Normalize both strings for comparison
        const normalizedCandidateSource = candidateSource.toLowerCase().trim();
        const normalizedSelectedSource = selectedSource.toLowerCase().trim();

        // Handle different spellings and variations
        let matches = normalizedCandidateSource === normalizedSelectedSource;

        // Special handling for LinkedIn variations
        if (normalizedSelectedSource === "linkedin") {
          matches =
            matches ||
            normalizedCandidateSource === "linkedin" ||
            normalizedCandidateSource === "linqdin" ||
            normalizedCandidateSource === "linkdin" ||
            normalizedCandidateSource.includes("linkedin");
        }

        return matches;
      });
    }

    // Apply date range filter
    if (filterDateRange[0] && filterDateRange[1]) {
      filteredData = filteredData.filter((candidate) => {
        if (
          !candidate.applied_at &&
          !candidate.created_at &&
          !candidate.application_date
        )
          return false;
        const candidateDate = new Date(
          candidate.applied_at ||
          candidate.created_at ||
          candidate.application_date
        );
        const startDate = new Date(filterDateRange[0]);
        const endDate = new Date(filterDateRange[1]);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
        return candidateDate >= startDate && candidateDate <= endDate;
      });
    }

    // Apply sorting if specified
    if (sortColumn && sortDirection) {
      filteredData = [...filteredData].sort((a, b) => {
        if (sortColumn === "name") {
          const comparison = a.name.localeCompare(b.name);
          return sortDirection === "asc" ? comparison : -comparison;
        } else if (sortColumn === "score") {
          const comparison = (a.score || 0) - (b.score || 0);
          return sortDirection === "asc" ? comparison : -comparison;
        }
        return 0;
      });
    }

    return filteredData;
  };

  const currentData = useMemo(
    () => getCurrentData(),
    [
      shortlisted,
      retrofit,
      activeTab,
      sortColumn,
      sortDirection,
      searchQuery,
      selectedSource,
      filterDateRange,
    ]
  );

  const totalItems = useMemo(() => currentData.length, [currentData]);
  const totalPages = useMemo(
    () => Math.ceil(totalItems / itemsPerPage),
    [totalItems, itemsPerPage]
  );
  const startIndex = useMemo(
    () => (currentPage - 1) * itemsPerPage,
    [currentPage, itemsPerPage]
  );
  const endIndex = useMemo(
    () => startIndex + itemsPerPage,
    [startIndex, itemsPerPage]
  );
  const currentItems = useMemo(
    () => currentData.slice(startIndex, endIndex),
    [currentData, startIndex, endIndex]
  );

  //Download Resume
  const handleViewResume = async () => {
    if (currentCandidate.resume_s3_url) {
      try {
        const response = await axios.get(
          `${host}/download-resumes3?resume_s3_url=${encodeURIComponent(currentCandidate.resume_s3_url)}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            responseType: "blob",
          }
        );

        const contentDisposition = response.headers["content-disposition"];
        const contentType =
          response.headers["content-type"] || "application/octet-stream";

        let filename = `${currentReport.name}_resume.pdf`;
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, "");
          }
        } else {
          const candidateName = (currentReport.name || "candidate")
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .replace(/\s+/g, "_");
          filename = `${candidateName}_resume`;
        }

        let extension = "pdf";
        if (contentType.includes("wordprocessingml")) extension = "docx";
        else if (contentType.includes("msword")) extension = "doc";
        else if (contentType.includes("pdf")) extension = "pdf";

        if (!filename.endsWith(`.${extension}`)) {
          filename = `${filename}.${extension}`;
        }

        const blob = new Blob([response.data], { type: contentType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = filename;
          link.style.display = "none";
          link.setAttribute("target", "_self");

          document.body.appendChild(link);

          setTimeout(() => {
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
          }, 100);
        }

        toast.success("Resume downloaded successfully");
      } catch (error) {
        console.error("Download error:", error);

        if (error.response?.status === 404) {
          const errorMessage =
            error.response?.data?.detail || "Resume not found";
          toast.error(errorMessage);
        } else if (error.response?.status === 401) {
          toast.error("Unauthorized access. Please login again.");
        } else if (error.response?.status === 400) {
          const errorMessage =
            error.response?.data?.detail || "Invalid request";
          toast.error(errorMessage);
        } else if (error.response?.status === 500) {
          toast.error("Server error. Please try again later.");
        } else {
          toast.error("Download failed. Please try again.");
        }
      }
    }
  };

  useEffect(() => {
    if (jobId && accessToken) {
      const loadAllData = async () => {
        try {
          // Only fetch candidates, remove analytics
          await fetchCandidatesByJob(jobId);
        } catch (error) {
          console.error("Error during data loading:", error);
          toast.error("Failed to load candidates");
        }
      };

      loadAllData();
    }
  }, [jobId, accessToken]);

  useEffect(() => {
    if (currentItems.length === 0) {
      setSelectAllCandidates(false);
    } else {
      const allCurrentPageSelected = currentItems.every((item) =>
        selectedCandidates.some((selected) => selected._id === item._id)
      );
      setSelectAllCandidates(allCurrentPageSelected);
    }
  }, [selectedCandidates, currentItems]);

  useEffect(() => {
    setCurrentPage(1);
  }, [jobId]);

  const fetchCandidatesByJob = async (jobId) => {
    setIsLoading(true);
    try {
      console.log("Fetching sourced candidates for job:", jobId);

      // SINGLE API CALL - replaces N+1 calls using bulk endpoint
      const response = await axios.get(`${host}/sourced-candidates/bulk`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          jd_id: jobId,
        },
      });

      const allCandidates = response.data.candidates || [];
      console.log(
        `Bulk sourced candidates fetch completed: ${allCandidates.length} candidates`
      );

      setCandidates(allCandidates);
      setIsLoading(false);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error in bulk sourced candidates fetch:", error);
      setCandidates([]);
      setIsLoading(false);
    }
  };

  const handleScoreSortClick = () => {
    if (sortColumn === "score") {
      // Toggle between desc and asc
      const newDirection = sortDirection === "desc" ? "asc" : "desc";
      setSortColumn("score");
      setSortDirection(newDirection);
    } else {
      // First click - start with high to low (desc)
      setSortColumn("score");
      setSortDirection("desc");
    }
  };

  const handleNameSortClick = () => {
    if (sortColumn === "name") {
      // Toggle between asc and desc
      const newDirection = sortDirection === "asc" ? "desc" : "asc";
      setSortColumn("name");
      setSortDirection(newDirection);
    } else {
      // First click - start with A to Z (asc)
      setSortColumn("name");
      setSortDirection("asc");
    }
  };

  const downloadExcel = () => {
    if (currentData.length === 0) {
      toast.error("No candidates to download");
      return;
    }

    const data = getCurrentData().map((candidate, index) => ({
      "Sr. No.": startIndex + index + 1,
      "Candidate Name": candidate.name || "N/A",
      "Email Id": candidate.candidate_email || "NA",
      Source:
        candidate.source_of_application &&
          candidate.source_of_application !== "Other"
          ? candidate.source_of_application
          : candidate.source_of_application === "Other" &&
            candidate.other_source_details
            ? `Other: ${candidate.other_source_details}`
            : candidate.source_of_application === "Other"
              ? "Other"
              : "Not Specified",
      Score: candidate.score,
      "Applied Date": new Date(candidate.applied_at).toLocaleDateString(),
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sourced Candidates");

    const wscols = [
      { wch: 10 },
      { wch: 30 },
      { wch: 40 },
      { wch: 10 },
      { wch: 15 },
      { wch: 15 },
    ];
    worksheet["!cols"] = wscols;

    XLSX.writeFile(
      workbook,
      `sourced_candidates_${jobRole}_${new Date().toISOString().split("T")[0]
      }.xlsx`
    );
  };

  // Filter helper functions
  const handleFilterSelect = (source) => {
    setTempSelectedSource(source);
  };

  const handleResetDateRange = () => {
    setTempFilterDateRange([null, null]);
    setFilterDateRange([null, null]);
  };

  const handleApplyFilters = () => {
    setSelectedSource(tempSelectedSource);
    setFilterDateRange(tempFilterDateRange);
    setShowFilterDropdown(false);
    setCurrentPage(1); // Reset to first page when filters change
  };

  const handleResetFilter = () => {
    setShowFilterDropdown(false);
    setTempSelectedSource("All");
    setSelectedSource("All");
    setTempFilterDateRange([null, null]);
    setFilterDateRange([null, null]);
    setCurrentPage(1);
  };

  const getActiveFilters = () => {
    const activeFilters = [];
    if (selectedSource !== "All") {
      activeFilters.push({
        label: `Source: ${selectedSource}`,
        onRemove: () => {
          setSelectedSource("All");
          setTempSelectedSource("All");
        },
      });
    }
    if (filterDateRange[0] && filterDateRange[1]) {
      const formatDate = (date) =>
        new Date(date).toLocaleDateString("en-US", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
      activeFilters.push({
        label: `Date: ${formatDate(filterDateRange[0])} - ${formatDate(
          filterDateRange[1]
        )}`,
        onRemove: () => {
          setFilterDateRange([null, null]);
          setTempFilterDateRange([null, null]);
        },
      });
    }
    return activeFilters;
  };

  const activeFilters = getActiveFilters();
  const filterCount = activeFilters.length;

  // Get unique sources for filter dropdown
  const uniqueSources = useMemo(() => {
    // Get sources from actual candidate data
    const candidateSources = [...shortlisted, ...retrofit]
      .map((candidate) => {
        // Use source_of_application first, then source (same as filter logic)
        const source = candidate.source_of_application || candidate.source;
        return source;
      })
      .filter(
        (source) =>
          source &&
          source.trim() &&
          source.toLowerCase() !== "public_application"
      )
      .map((source) => source.trim());

    // Predefined common job portals (at the end)
    const predefinedSources = ["LinkedIn", "Naukri", "Monster"];

    // Combine: candidate sources first, then predefined sources
    const allSources = [...candidateSources, ...predefinedSources].filter(
      (source, index, array) => array.indexOf(source) === index
    );

    return ["All", ...allSources];
  }, [shortlisted, retrofit]);

  const getPathColor = (val) => {
    switch (true) {
      case val >= 60:
        return "#34B53A";
      case val >= 30 && val < 60:
        return "#FFB200";
      case val >= 0 && val < 30:
        return "#DC0000";
      default:
        return "gray";
    }
  };

  const getScoreColorGradient = (score) => {
    switch (true) {
      case score >= 60:
        return "rgba(0,255,0,0.2)";
      case score >= 30 && score < 60:
        return "rgba(255, 255, 0, 0.2)";
      case score >= 0 && score < 30:
        return "rgba(255, 0, 0, 0.2)";
      default:
        return "text-[#CCCCCCE5]";
    }
  };

  const SkillBadge = ({ skill, status }) => {
    return (
      <div className="flex items-center gap-1.5">
        <span className="dark:text-gray-300 text-textPrimary">{skill}</span>
        {status === "yes" ? (
          <CheckCircle className="w-4 h-4 text-green-500" />
        ) : (
          <XCircle className="w-4 h-4 text-red-500" />
        )}
      </div>
    );
  };

  const formatDateRange = (dateRange) => {
    if (!dateRange[0] || !dateRange[1]) return "Select Date Range";
    return `${dateRange[0].toLocaleDateString()} to ${dateRange[1].toLocaleDateString()}`;
  };


  const handleCheckboxChange = (candidate) => {
    setSelectedCandidates((prevSelected) => {
      const isSelected = prevSelected.some((c) => c._id === candidate._id);
      const newSelected = isSelected
        ? prevSelected.filter((c) => c._id !== candidate._id)
        : [...prevSelected, candidate];
      return newSelected;
    });
  };

  const handleSelectAllCandidates = () => {
    if (selectAllCandidates) {
      const pageItemIds = currentItems.map((item) => item._id);
      setSelectedCandidates((prev) =>
        prev.filter((candidate) => !pageItemIds.includes(candidate._id))
      );
      setSelectAllCandidates(false);
    } else {
      const pageItemIds = currentItems.map((item) => item._id);
      const newSelections = currentItems.filter(
        (item) =>
          !selectedCandidates.some((selected) => selected._id === item._id)
      );
      setSelectedCandidates((prev) => [...prev, ...newSelections]);
      setSelectAllCandidates(true);
    }
  };

  const scheduleInterviewForAll = async () => {
    if (selectedCandidates.length === 0) {
      toast.error("Please select candidates to schedule interviews");
      return;
    }
    if (!dateRange[0] || !dateRange[1]) {
      toast.error("Please select interview date range");
      return;
    }

    setIsLoading(true);
    try {
      const unscheduledCandidates = selectedCandidates.filter((candidate) => {
        if (candidate.interview_id && candidate.status === "scheduled") {
          return false;
        }
        return true;
      });

      if (unscheduledCandidates.length === 0) {
        toast.warning("All selected candidates already scheduled");
        setIsLoading(false);
        return;
      }

      const schedulePromises = unscheduledCandidates.map(async (candidate) => {
        const jobConfigResponse = await axios.get(`${host}/getjd`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            jd_id: candidate.jd_id || candidate.job_id,
          },
        });

        const jobConfig = jobConfigResponse.data;

        const formData = new FormData();
        formData.append("name", candidate.name);
        formData.append("candidate_email", candidate.candidate_email);
        formData.append("mcq_set_id", jobConfig.mcq_set_id || "");
        formData.append(
          "Coding_Judge_Criteria",
          JSON.stringify(jobConfig.Coding_Judge_Criteria || [])
        );
        formData.append("coding_set", jobConfig.Coding_set || "");
        formData.append(
          "mcq_time_limit",
          String(jobConfig.mcq_time_limit || 0)
        );
        formData.append(
          "coding_time_limit",
          String(jobConfig.coding_time_limit || 0)
        );
        formData.append(
          "typing_time_limit",
          String(jobConfig.typing_time_limit || 0)
        );
        formData.append(
          "selected_behavioral_set",
          jobConfig.selected_behavioral_set || ""
        );
        formData.append("start_date", dateRange[0].toISOString());
        formData.append("end_date", dateRange[1].toISOString());
        formData.append("job_id", candidate.jd_id || candidate.job_id);
        formData.append("job_role", jobConfig.jobrole || "");
        formData.append(
          "job_description",
          JSON.stringify(jobConfig.description || {})
        );
        formData.append("resume_content", candidate.resume_content || "");
        formData.append("resume_s3_url", candidate.resume_s3_url || "");
        formData.append("score", String(candidate.score || 0));
        formData.append("interview_type", jobConfig.interview_type || "");
        formData.append("questionType", jobConfig.questionType || "");
        formData.append(
          "interview_timelimit",
          String(jobConfig.interview_timelimit || 0)
        );
        formData.append("report", JSON.stringify(candidate.report || {}));
        formData.append(
          "education_match",
          JSON.stringify(candidate.education_match || {})
        );
        formData.append(
          "tech_tool_match",
          JSON.stringify(candidate.tech_tool_match || [])
        );
        formData.append(
          "experience_match",
          JSON.stringify(candidate.experience_match || [])
        );
        formData.append("red_flags", JSON.stringify(candidate.red_flags || []));
        formData.append(
          "location_match",
          JSON.stringify(candidate.location_match || {})
        );
        formData.append("mobile", candidate.mobile || "");
        formData.append("source_of_application", candidate.source_of_application);
        formData.append("notice_period", candidate.notice_period);
        formData.append("orgid",org_id)
        if (jobConfig.customQuestions && jobConfig.customQuestions.length > 0) {
          formData.append(
            "custom_questions",
            JSON.stringify(jobConfig.customQuestions)
          );
        }

        const response = await axios.post(
          `${host}/store_candidate_data`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        return response.data;
      });

      await Promise.all(schedulePromises);

      const remainingCandidates = candidates.filter((candidate) => {
        return !unscheduledCandidates.some(
          (scheduled) => scheduled._id === candidate._id
        );
      });
      setCandidates(remainingCandidates);

      const newTotalPages = Math.ceil(
        remainingCandidates.length / itemsPerPage
      );
      if (remainingCandidates.length === 0 || newTotalPages === 0) {
        setCurrentPage(1);
      } else if (currentPage > newTotalPages) {
        setCurrentPage(newTotalPages);
      }

      setSelectedCandidates([]);
      setSelectAllCandidates(false);
      setDateRange([null, null]);
      setIsSchedulePopup(false);
      setIsLoading(false);

      const skippedCount =
        selectedCandidates.length - unscheduledCandidates.length;
      if (skippedCount > 0) {
        toast.success(
          `${unscheduledCandidates.length} interviews scheduled successfully`
        );
      } else {
        toast.success(
          `${unscheduledCandidates.length} interviews scheduled successfully`
        );
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          Cookies.remove("accessToken");
          toast.error(`Unauthorized: ${detail}`);
        } else {
          toast.error(`Failed to schedule interviews: ${detail}`);
        }
      } else {
        toast.error("Something went wrong. Please try again");
      }
    }
  };

  const deleteSelectedCandidates = async () => {
    setIsDeletePopup(false);
    const candidateIds = selectedCandidates.map((candidate) => candidate._id);

    try {
      await axios.delete(`${host}/sourced-candidates/delete`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: {
          candidate_ids: candidateIds,
        },
      });

      toast.success("Candidates deleted successfully");

      setCandidates((prev) =>
        prev.filter((candidate) => !candidateIds.includes(candidate._id))
      );
      setSelectedCandidates([]);
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          Cookies.remove("accessToken");
          toast.error(`Unauthorized: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error("Something went wrong. Please try again");
      }
    }
  };

  // Add shortlist functionality - move retrofit candidates to shortlisted
  const shortlistSelectedCandidates = () => {
    const candidatesToShortlist = selectedCandidates.filter(
      (candidate) => candidate.score < resumeScoreThreshold
    );

    // Remove from retrofit and add to shortlisted
    setRetrofit(retrofit.filter((c) => !candidatesToShortlist.includes(c)));
    setShortlisted([...shortlisted, ...candidatesToShortlist]);

    // Clear selection
    setSelectedCandidates([]);

    const count = candidatesToShortlist.length;

    toast.success(
      `${count} ${count === 1 ? "candidate" : "candidates"} shortlisted`
    );
  };

  const handleReportClick = (candidate) => {
    setCurrentReport({
      score: candidate.score,
      experience_match: candidate.experience_match || [],
      location_match: candidate.location_match || {},
      education_match: candidate.education_match || {},
      tech_tool_match: candidate.tech_tool_match || [],
      red_flags: candidate.red_flags || [],
      Strengths: candidate.report?.Strengths || [],
      Weaknesses: candidate.report?.Weaknesses || [],
      Suggestions: candidate.report?.Suggestions || [],
      name: candidate.name,

      // ── NEW FIELDS ───────────────────────────────
      designation: candidate.designation || "NA",
      current_employer: candidate.current_employer || "NA",
      current_ctc: candidate.current_ctc || "NA",
      expected_ctc: candidate.expected_ctc || "NA",
      experience_years: candidate.experience_years || "NA",
      visa_status: candidate.visa_status || "NA",
      languages_known: candidate.languages_known || "NA",
      college_years: candidate.college_years || "NA",
      source_of_application: candidate.source_of_application || "NA",
      relatives_in_company: candidate.relatives_in_company || "NA",
      current_benefits: candidate.current_benefits || "NA",
      gender: candidate.gender || "NA",
      marital_status: candidate.marital_status || "NA",
      expected_joining_date: candidate.expected_joining_date || "NA",
      notice_period: candidate.notice_period || "NA",
      other_source_details: candidate.other_source_details || "NA",
    });
    setAdditionalInfoPage(0);
    setCurrentCandidate(candidate);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentReport(null);
    setCurrentCandidate(null);
  };

  const startEditingEmail = (candidate) => {
    setEditingCandidateId(candidate._id);
    setNewEmail(candidate.candidate_email || "");
  };

  const cancelEditingEmail = () => {
    setEditingCandidateId(null);
    setNewEmail("");
  };

  const saveEmailChange = async (candidate) => {
    if (!newEmail) {
      toast.error("Please enter an email");
      return;
    }

    if (newEmail === candidate.candidate_email) {
      toast.info("No changes made");
      cancelEditingEmail();
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(newEmail)) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      const params = new URLSearchParams({
        candidate_id: candidate._id,
        new_email: newEmail,
      });

      await axios.put(
        `${host}/sourced-candidates/update-email`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: params,
        }
      );

      const updatedCandidates = candidates.map((c) =>
        c._id === candidate._id ? { ...c, candidate_email: newEmail } : c
      );
      setCandidates(updatedCandidates);

      toast.success("Email updated successfully");
      cancelEditingEmail();
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 400) {
          toast.error(`Validation Error: ${detail}`);
        } else if (status === 401) {
          Cookies.remove("accessToken");
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 404) {
          toast.error(`Not Found: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error("Something went wrong. Please try again");
      }
    }
  };

  const handleSortClick = (column, direction) => {
    setSortColumn(column);
    setSortDirection(direction);
    setIsSortOpen(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }

    return pages;
  };

  const formatJobDescription = (jobRole, data) => {
    if (data.Required_Skills?.skill_based) {
      const skillBasedData = data.Required_Skills?.skill_based || [];
      const skillsDisplay = skillBasedData
        .map((skill) => {
          const topics =
            skill.topics && skill.topics.length > 0
              ? ` (${skill.topics.join(", ")})`
              : "";
          return `• ${skill.skill_name}${topics}`;
        })
        .join("\n");

      return (
        <pre className="font-sans glass-effect text-md whitespace-pre-wrap break-words p-6 rounded-2xl max-h-[70vh] overflow-y-auto shadow-inner text-white">
          {`Position: ${jobRole}\nExperience Range: ${data.minExp || 0} - ${data.maxExp || 1
            } years\n\nRequired Skills:\n${skillsDisplay || "- None"}\n\n${data.Roles_and_Responsibilities?.length
              ? `Roles & Responsibilities:\n${data.Roles_and_Responsibilities.map(
                (item, i) => `${i + 1}. ${item}`
              ).join("\n")}`
              : ""
            }\n\n${data.Tools_and_Technologies?.length
              ? `Tools & Technologies:\n  ${data.Tools_and_Technologies.join(
                ", "
              )}\n\n`
              : ""
            }${data.GoodtoHave?.length
              ? `Good to Have:\n  ${data.GoodtoHave.join(", ")}\n\n`
              : ""
            }`}
        </pre>
      );
    } else {
      const experience = (data.minExp + data.maxExp) / 2;
      return (
        <pre className="font-sans glass-effect text-md whitespace-pre-wrap break-words p-6 rounded-2xl max-h-[70vh] overflow-y-auto shadow-inner text-white">
          {`Position: ${jobRole}\nExperience Range: ${data.minExp} - ${data.maxExp
            } years \n\nRequired Skills:\n${experience < 4
              ? data.Required_Skills?.Medium?.length
                ? data.Required_Skills.Medium.map(
                  (skill, i) => `${i + 1}. ${skill}`
                ).join("\n")
                : "- None"
              : data.Required_Skills?.Hard?.length
                ? data.Required_Skills.Hard.map(
                  (skill, i) => `${i + 1}. ${skill}`
                ).join("\n")
                : "- None"
            }\n\nOptional Skills:\n${experience < 4
              ? data.Required_Skills?.Easy?.join(", ") || "None"
              : data.Required_Skills?.Medium?.join(", ") || "None"
            }\n\n${data.Roles_and_Responsibilities?.length
              ? `Roles & Responsibilities:\n${data.Roles_and_Responsibilities.map(
                (item, i) => `${i + 1}. ${item}`
              ).join("\n")}`
              : ""
            }\n\n${data.Tools_and_Technologies?.length
              ? `Tools & Technologies:\n  ${data.Tools_and_Technologies.join(
                ", "
              )}\n\n`
              : ""
            }${data.GoodtoHave?.length
              ? `Good to Have:\n  ${data.GoodtoHave.join(", ")}\n\n`
              : ""
            }`}
        </pre>
      );
    }
  };

  const renderTable = (data) => {
    if (data.length === 0) {
      return (
        <div className="flex items-center justify-center min-h-[200px] mt-6 border rounded-lg border-gray-700/50">
          <p className="text-gray-400 text-sm">No candidates found</p>
        </div>
      );
    }

    const tableHeightClass = "";

    return (
      <>
        <div className="flex-1 w-full mt-6 rounded-lg border-gray-700/50 overflow-hidden">
          <table className="w-full table-fixed">
            <thead className="relative border-b border-[#5A4479D4]">
              <div className="absolute inset-0 pointer-events-none dark:hidden"></div>

              <tr>
                <th className="text-center px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary w-[50px] py-4">
                  <input
                    type="checkbox"
                    className="rounded bg-gray-700 border-gray-600 w-4 h-4 accent-blue-600 cursor-pointer"
                    checked={selectAllCandidates}
                    onChange={handleSelectAllCandidates}
                    title="Select All"
                  />
                </th>

                <th
                  className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary relative"
                  style={{ width: getColumnWidth('candidateName') }}
                >
                  <div className="flex items-center cursor-pointer truncate" onClick={handleNameSortClick} title="Candidate Name">
                    Candidate Name
                    {sortColumn === "name" ? (
                      sortDirection === "asc" ? (
                        <ArrowUpAZ className="w-4 h-4 ml-2 dark:text-white text-textSecondary flex-shrink-0" />
                      ) : (
                        <ArrowDownZA className="w-4 h-4 ml-2 dark:text-white text-textSecondary flex-shrink-0" />
                      )
                    ) : (
                      <ArrowUpDown className="w-4 h-4 ml-2 dark:text-gray-400 text-textSecondary flex-shrink-0" />
                    )}
                  </div>
                </th>

                <th
                  className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary truncate"
                  title="Email Id"
                  style={{ width: getColumnWidth('emailId') }}
                >
                  Email Id
                </th>

                <th
                  className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary truncate"
                  title="Contact Number"
                  style={{ width: getColumnWidth('contactNumber') }}
                >
                  Contact Number
                </th>

                {customAtsFormEnabled && visibleColumns.gender && (
                  <th
                    className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary truncate"
                    title="Gender"
                    style={{ width: getColumnWidth('gender') }}
                  >
                    Gender
                  </th>
                )}

                {customAtsFormEnabled && visibleColumns.currentCTC && (
                  <th
                    className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary truncate"
                    title="Current CTC"
                    style={{ width: getColumnWidth('currentCTC') }}
                  >
                    Current CTC
                  </th>
                )}

                {visibleColumns.source && (
                  <th
                    className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary truncate"
                    title="Source"
                    style={{ width: getColumnWidth('source') }}
                  >
                    Source
                  </th>
                )}

                {visibleColumns.noticePeriod && (
                  <th
                    className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary truncate"
                    title="Notice Period"
                    style={{ width: getColumnWidth('noticePeriod') }}
                  >
                    Notice Period
                  </th>
                )}

                <th
                  className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary relative"
                  style={{ width: getColumnWidth('resumeScore') }}
                >
                  <div className="flex items-center cursor-pointer truncate" onClick={handleScoreSortClick} title="Resume Score">
                    Resume Score
                    {sortColumn === "score" ? (
                      sortDirection === "desc" ? (
                        <ArrowDown10 className="w-4 h-4 ml-2 dark:text-white text-textSecondary flex-shrink-0" />
                      ) : (
                        <ArrowUp10 className="w-4 h-4 ml-2 dark:text-white text-textSecondary flex-shrink-0" />
                      )
                    ) : (
                      <ArrowUpDown className="w-4 h-4 ml-2 dark:text-gray-400 text-textSecondary flex-shrink-0" />
                    )}
                  </div>
                </th>

                {visibleColumns.appliedDate && (
                  <th
                    className="text-left px-2 text-sm font-medium dark:text-[#CCCCCC] text-textSecondary pt-1.5 pb-1.5 truncate"
                    title="Applied Date"
                    style={{ width: getColumnWidth('appliedDate') }}
                  >
                    Applied Date
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {currentItems.map((candidate, index) => (
                <tr
                  key={candidate._id}
                  className="border-b dark:border-gray-700/50 border-gray-300/50 dark:hover:bg-gray-800 hover:bg-gray-100 transition-colors cursor-pointer hover:text-white group"
                  onClick={(e) => {
                    const checkboxColumn = e.target.closest("td:nth-child(1)");
                    if (
                      checkboxColumn ||
                      e.target.tagName === "BUTTON" ||
                      e.target.tagName === "INPUT" ||
                      e.target.closest("button") ||
                      e.target.closest("input")
                    ) {
                      e.stopPropagation();
                      return;
                    }
                    handleReportClick(candidate);
                  }}
                >
                  <td className="px-2 py-4 text-center">
                    <input
                      type="checkbox"
                      className="rounded bg-gray-700 border-gray-600 w-4 h-4 accent-blue-600 cursor-pointer"
                      checked={selectedCandidates.some(
                        (c) => c._id === candidate._id
                      )}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleCheckboxChange(candidate);
                      }}
                    />
                  </td>
                  <td className="px-2 py-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                    <div className="truncate" title={candidate.name}>
                      {candidate.name}
                    </div>
                  </td>
                  <td className="px-2 py-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                    <div className="flex items-center space-x-2">
                      {editingCandidateId === candidate._id ? (
                        <input
                          type="email"
                          value={newEmail}
                          onChange={(e) => setNewEmail(e.target.value)}
                          placeholder="Enter email"
                          required
                          className="bg-transparent flex-1 border border-gray-600 dark:text-[#CCCCCC] text-textSecondary px-2 py-1 rounded text-sm min-w-0"
                          onClick={(e) => e.stopPropagation()}
                        />
                      ) : (
                        <span className="flex-1 min-w-0 truncate" title={candidate.candidate_email || "NA"}>
                          {candidate.candidate_email || "NA"}
                        </span>
                      )}
                      {editingCandidateId === candidate._id ? (
                        <div className="flex space-x-1 flex-shrink-0">
                          <button
                            className="p-1 rounded hover:bg-gray-700"
                            onClick={(e) => {
                              e.stopPropagation();
                              saveEmailChange(candidate);
                            }}
                            title="Save changes"
                          >
                            <Check size={16} className="text-green-400" />
                          </button>
                          <button
                            className="p-1 rounded hover:bg-gray-700"
                            onClick={(e) => {
                              e.stopPropagation();
                              cancelEditingEmail();
                            }}
                            title="Cancel editing"
                          >
                            <XCircle size={16} className="text-red-400" />
                          </button>
                        </div>
                      ) : (
                        <button
                          className="p-1 rounded hover:bg-gray-700 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0"
                          onClick={(e) => {
                            e.stopPropagation();
                            startEditingEmail(candidate);
                          }}
                          title="Edit email"
                        >
                          <Pencil size={16} className="text-gray-400" />
                        </button>
                      )}
                    </div>
                  </td>

                  <td className="px-2 py-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                    <div className="truncate" title={candidate.mobile || "NA"}>
                      {candidate.mobile || "NA"}
                    </div>
                  </td>

                  {customAtsFormEnabled && visibleColumns.gender && (
                    <td className="px-2 py-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                      <div className="truncate" title={candidate.gender || "NA"}>
                        {candidate.gender || "NA"}
                      </div>
                    </td>
                  )}

                  {customAtsFormEnabled && visibleColumns.currentCTC && (
                    <td className="px-2 py-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                      <div className="truncate" title={candidate.current_ctc || "NA"}>
                        {candidate.current_ctc || "NA"}
                      </div>
                    </td>
                  )}

                  {visibleColumns.source && (
                    <td className="px-2 py-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                      {(() => {
                        const displaySource = candidate.source_of_application &&
                          candidate.source_of_application !== "Other"
                          ? candidate.source_of_application
                          : candidate.source_of_application === "Other" &&
                            candidate.other_source_details
                            ? `Other: ${candidate.other_source_details}`
                            : candidate.source_of_application === "Other"
                              ? "Other"
                              : "Not Specified";
                        return (
                          <div className="truncate" title={displaySource}>
                            {displaySource}
                          </div>
                        );
                      })()}
                    </td>
                  )}

                  {visibleColumns.noticePeriod && (
                    <td className="px-2 py-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                      <div className="truncate" title={candidate.notice_period || "NA"}>
                        {candidate.notice_period || "NA"}
                      </div>
                    </td>
                  )}

                  <td className="px-2 py-4 text-sm text-[#CCCCCC]">
                    <div
                      className={`flex items-center justify-center border w-9 p-0.5 rounded-lg ${candidate.score >= 70
                        ? "border-green-600 text-green-400"
                        : candidate.score >= 30
                          ? "border-yellow-600 text-yellow-400"
                          : "border-red-600 text-red-400"
                        }`}
                    >
                      <span>{candidate.score}</span>
                    </div>
                  </td>
                  {visibleColumns.appliedDate && (
                    <td className="px-2 py-4 text-sm dark:text-[#CCCCCC] text-textSecondary">
                      <div className="truncate" title={candidate.applied_at.split("T")[0]}>
                        {candidate.applied_at.split("T")[0]}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {totalPages >= 1 && (
          <div className="px-2 py-4 border-gray-700/50 flex items-center justify-between space-x-5 mt-4">
            <div className="flex items-center space-x-4 my-4">
              <span className="text-sm dark:text-[#D9D9D9] text-textSecondary">
                Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of{" "}
                {totalItems} Candidates
              </span>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="p-2 rounded-full border border-gray-600 dark:text-gray-400 text-textSecondary  dark:hover:bg-gray-700/50 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <ChevronLeft className="w-6 h-6 border border-[#D9D9D9] rounded-md" />
                </button>

                {getPageNumbers().map((page, index) => (
                  <button
                    key={index}
                    onClick={() =>
                      typeof page === "number" && handlePageChange(page)
                    }
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm ${page === currentPage
                      ? "bg-gradient-to-r from-pink-500 to-blue-500 text-white"
                      : page === "..."
                        ? "text-gray-400 cursor-default"
                        : "dark:bg-gray-700 bg-gray-100 text-gray-400 dark:hover:bg-gray-600 hover:bg-gray-300"
                      }`}
                    disabled={page === "..."}
                  >
                    {page}
                  </button>
                ))}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-full border dark:border-gray-600 dark:text-gray-400 text-textSecondary  dark:hover:bg-gray-700/50 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <ChevronRight className="w-6 h-6 border border-[#D9D9D9] rounded-md" />
                </button>
              </div>
            </div>
            <div className="flex space-x-2">
              {activeTab === "shortlisted" && (
                <>
                  {(selectedShortlistedCandidates.length > 0 ||
                    selectedCandidates.length > 0) && (
                    <button
                      className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm button"
                      onClick={() => setIsSchedulePopup(!isSchedulePopup)}
                    >
                      <span>Schedule Interview</span>
                    </button>
                  )}
                </>
              )}
              {activeTab === "retrofit" && selectedCandidates.length > 0 && (
                <>
                  <button
                    className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm button"
                    onClick={shortlistSelectedCandidates}
                  >
                    <span>Shortlist Selected Candidates</span>
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="flex flex-col items-center text-center">
          <Loader />
          <p className="dark:text-[#8893C8] text-textSecondary text-sm mt-4">Loading candidates...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen text-white  p-2 ">
      <style>{calendarOverrideStyles}</style>
      <div className="flex-1 px-0 relative h-full flex flex-col">
        {!isLoading ? (
          <>
            {/* Controls section - always visible - tabs and controls on same line */}
            <div
              className="flex items-center justify-between mt-4"
              onClick={(e) => e.stopPropagation()}
              style={{ position: "relative", zIndex: 10 }}
            >
              <div className="flex space-x-4">
                <button
                  key="shortlisted-tab"
                  onClick={(e) => {
                    e.stopPropagation();
                    try {
                      handleTabChange("shortlisted");
                    } catch (error) { }
                  }}
                  className={`${activeTab === "shortlisted"
                    ? "button"
                    : "border border-gray-700/50 py-2 px-4 rounded-full dark:text-gray-400 text-textSecondary"
                    }`}
                  style={{ pointerEvents: "auto", cursor: "pointer" }}
                >
                  <span>{`Shortlisted (${shortlisted.length})`}</span>
                </button>
                <button
                  key="retrofit-tab"
                  onClick={(e) => {
                    e.stopPropagation();
                    try {
                      handleTabChange("retrofit");
                    } catch (error) { }
                  }}
                  className={`${activeTab === "retrofit"
                    ? "button"
                    : "border border-gray-700/50 py-2 px-4 rounded-full dark:text-gray-400 text-textSecondary"
                    }`}
                  style={{ pointerEvents: "auto", cursor: "pointer" }}
                >
                  <span>{`Retrofit (${retrofit.length})`}</span>
                </button>
              </div>
              <div className="flex items-center space-x-4">
                {/* Search Bar */}
                <div className="relative flex items-center">
                  <Search className="absolute left-3 w-5 h-5 dark:text-gray-400 text-textSecondary" />
                  <input
                    type="text"
                    placeholder="Search by Name"
                    value={searchQuery}
                    autoComplete="off"
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                    className="pl-10 pr-10 py-2 dark:bg-gray-800/50 bg-bgPrimary border border-gray-600 rounded-full dark:text-white text-textSecondary text-sm focus:outline-none focus:ring-1 focus:ring-white transition-all"
                  />
                  {searchQuery && (
                    <CircleX
                      className="absolute right-3 w-5 h-5 text-gray-400 cursor-pointer dark:hover:text-white hover:text-gray-500"
                      onClick={() => {
                        setSearchQuery("");
                        setCurrentPage(1);
                      }}
                    />
                  )}
                </div>

                {/* Filter Button */}
                <div className="relative" ref={filterRef}>
                  <button
                    className="flex items-center gap-2 dark:glass-effect border dark:border-gray-600 border-gray-300 rounded-full px-3 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-100 text-sm font-light"
                    onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                  >
                    <SlidersHorizontal className="w-4 h-4" />
                    <span>Filter</span>
                    {filterCount > 0 && (
                      <span className="ml-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs absolute -right-2 -top-1">
                        {filterCount}
                      </span>
                    )}
                  </button>
                    {showFilterDropdown && (
                      <div
                        className=" absolute right-0 mt-2 w-[400px] border border-gray-600 rounded-lg shadow-sm dark:shadow-lg z-20 p-6 dark:bg-[linear-gradient(233.57deg,rgba(34,52,97,0.25)_-5.01%,rgba(11,10,31,0.05)_100%)] bg-bgPrimary [backdrop-filter:blur(500px)]"
                      >
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-medium dark:text-[#D9D9D9] text-textSecondary">
                          Filter
                        </h3>
                        <button
                          onClick={() => setShowFilterDropdown(false)}
                          className="dark:text-gray-400 text-textSecondary dark:hover:text-white hover:text-gray-400"
                        >
                          <X className="w-5 h-5" />
                        </button>
                      </div>

                      {/* Filters */}
                      <div className="space-y-4">
                        {/* Active Filters */}
                        {activeFilters.length > 0 && (
                          <div className="mb-2">
                            <div className="flex items-center justify-between mb-2">
                              <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                                Active Filters
                              </label>
                              <button
                                onClick={handleResetFilter}
                                className="text-xs text-blue-400 hover:text-blue-300">
                                Clear All
                              </button>
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {activeFilters.map((filter, index) => (
                                <div
                                  key={index}
                                  className="flex items-center dark:bg-gray-700/50 bg-violet-600 dark:text-[#D9D9D9] text-xs px-3 py-1 rounded-full dark:border-green-400 border border-violet-900 text-white">
                                  <span>{filter.label}</span>
                                  <button
                                    onClick={filter.onRemove}
                                    className="ml-2 dark:text-gray-400 hover:text-white text-gray-200">
                                    <X className="w-4 h-4" />
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Source Filter */}
                        <div>
                          <label className="block text-sm dark:text-gray-300 text-textSecondary mb-2">
                            Source
                          </label>
                          <div className="space-y-2 max-h-32 overflow-y-auto">
                            {uniqueSources.map((source) => (
                              <label
                                key={source}
                                className="flex items-center space-x-2 cursor-pointer">
                                <input
                                  type="radio"
                                  name="source"
                                  value={source}
                                  checked={tempSelectedSource === source}
                                  onChange={() => handleFilterSelect(source)}
                                  className="text-blue-500 focus:ring-blue-500 accent-blue-600"
                                />
                                <span className="text-sm dark:text-gray-300 text-textSecondary">
                                  {source}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>

                        {/* Date Range Filter */}
                        <div className="space-y-2 mb-6">
                          <label className="block text-sm dark:text-gray-300 text-textSecondary mb-2">
                            Date Range
                          </label>
                          <div className="relative" ref={calendarRef}>
                            <button
                              className="flex items-center justify-between w-full dark:glass-effect bg-bgPrimary border border-gray-600 rounded-full px-4 py-2 dark:text-gray-300 text-textPrimary dark:hover:bg-gray-700/50 hover:bg-gray-50 text-sm font-light h-10"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsCalendarOpen(!isCalendarOpen);
                              }}
                              aria-expanded={isCalendarOpen}
                            >
                              <span className="truncate">
                                {formatDateRange(tempFilterDateRange)}
                              </span>
                              {tempFilterDateRange?.length === 2 && tempFilterDateRange[0] ? (
                                <X
                                  className="w-4 h-4"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setTempFilterDateRange([null, null]);
                                    setIsCalendarOpen(false);
                                  }}
                                />
                              ) : (
                                <ChevronDown className="w-4 h-4" />
                              )}
                            </button>
                            {isCalendarOpen && (
                              <div
                                className="candidate-analytics-calendar absolute mt-2 z-[100] right-0"
                                style={{
                                  background: theme === 'dark' ? "#0a1733" : "#fff",
                                  border: "1px solid #4b5563",
                                  borderRadius: "8px"
                                }}
                              >
                                <div className={`platform-calendar ${theme}`}>
                                  <PlatformCalendar
                                    onChange={(value) => {
                                      setTempFilterDateRange(value);
                                      if (value[0] && value[1]) {
                                        setIsCalendarOpen(false);
                                      }
                                    }}
                                    value={tempFilterDateRange}
                                    selectRange={true}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Filter Actions */}
                      <div className="flex space-x-2 pt-4 mt-3 border-t border-gray-600">
                        <button
                          onClick={handleResetFilter}
                          className="flex-1 px-4 py-2 border border-gray-600 rounded-full dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-200 text-sm"
                        >
                          Reset All
                        </button>
                        <button
                          onClick={handleApplyFilters}
                          className="flex-1 px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm hover:opacity-90"
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Delete Button */}
                <button
                  className="flex items-center gap-2 dark:glass-effect border dark:border-gray-600 border-gray-300 rounded-full px-3 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-100 text-sm font-light disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
                  onClick={() => setIsDeletePopup(true)}
                  disabled={selectedCandidates.length === 0}
                >
                  <Trash className="w-4 h-4 dark:text-[#C1A0D0] text-textSecondary" />
                  <span>Delete</span>
                </button>

                <div className="relative" ref={columnFilterRef}>
                  <button
                    className="flex items-center gap-2 dark:glass-effect border dark:border-gray-600 border-gray-300 rounded-full px-3 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-100 text-sm font-light"
                    onClick={() => setIsColumnFilterOpen(!isColumnFilterOpen)}
                  >
                    <Layout className="w-4 h-4" />
                    <span>Columns</span>
                  </button>
                  {isColumnFilterOpen && (
                    <div
                      className="absolute right-0 mt-2 w-60 border border-gray-600 rounded-lg shadow-sm dark:shadow-lg z-30 p-6 dark:bg-[linear-gradient(233.57deg,rgba(34,52,97,0.25)_-5.01%,rgba(11,10,31,0.05)_100%)] bg-bgPrimary [backdrop-filter:blur(500px)]"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-medium dark:text-[#D9D9D9] text-textSecondary">
                          Columns
                        </h3>
                        <button
                          onClick={() => setIsColumnFilterOpen(false)}
                          className="dark:text-gray-400 text-textSecondary dark:hover:text-white hover:text-gray-400"
                        >
                          <X className="w-5 h-5" />
                        </button>
                      </div>
                      <div className="flex flex-col gap-3">
                        <div className="flex space-x-3 mb-2">
                          <button
                            onClick={handleSelectAllColumns}
                            className="flex-1 px-2 py-1 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-xs hover:opacity-90 transition-opacity"
                          >
                            Select All
                          </button>
                        </div>

                        {customAtsFormEnabled && (
                          <>
                            <label className="flex items-center text-sm dark:text-[#D8D8D8] text-textSecondary cursor-pointer hover:opacity-80 transition-opacity">
                              <input
                                type="checkbox"
                                checked={visibleColumns.gender}
                                onChange={() => handleColumnToggle("gender")}
                                className="mr-2 accent-blue-500 h-4 w-4"
                              />
                              Gender
                            </label>
                            <label className="flex items-center text-sm dark:text-[#D8D8D8] text-textSecondary cursor-pointer hover:opacity-80 transition-opacity">
                              <input
                                type="checkbox"
                                checked={visibleColumns.currentCTC}
                                onChange={() => handleColumnToggle("currentCTC")}
                                className="mr-2 accent-blue-500 h-4 w-4"
                              />
                              Current CTC
                            </label>
                          </>
                        )}

                        <label className="flex items-center text-sm dark:text-[#D8D8D8] text-textSecondary cursor-pointer hover:opacity-80 transition-opacity">
                          <input
                            type="checkbox"
                            checked={visibleColumns.source}
                            onChange={() => handleColumnToggle("source")}
                            className="mr-2 accent-blue-500 h-4 w-4"
                          />
                          Source
                        </label>

                        <label className="flex items-center text-sm dark:text-[#D8D8D8] text-textSecondary cursor-pointer hover:opacity-80 transition-opacity">
                          <input
                            type="checkbox"
                            checked={visibleColumns.noticePeriod}
                            onChange={() => handleColumnToggle("noticePeriod")}
                            className="mr-2 accent-blue-500 h-4 w-4"
                          />
                          Notice Period
                        </label>

                        <label className="flex items-center text-sm dark:text-[#D8D8D8] text-textSecondary cursor-pointer hover:opacity-80 transition-opacity">
                          <input
                            type="checkbox"
                            checked={visibleColumns.appliedDate}
                            onChange={() => handleColumnToggle("appliedDate")}
                            className="mr-2 accent-blue-500 h-4 w-4"
                          />
                          Applied Date
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                <button
                  className="flex items-center gap-2 dark:glass-effect border dark:border-gray-600 border-gray-300 rounded-full px-3 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-100 text-sm font-light"
                  onClick={downloadExcel}
                >
                  <Download className="w-4 h-4 dark:text-[#C1A0D0] text-textSecondary" />
                  <span>Download Excel</span>
                </button>
              </div>
            </div>
            {renderTable(currentData)}
          </>
        ) : (
          <Loader />
        )}

        {/* Analysis Report Modal */}
        <Dialog
          open={!!currentReport}
          onClose={closeModal}
          maxWidth="md"
          scroll="body"
          fullWidth
          PaperProps={theme === "dark"
            ? {
              sx: {
                background:
                  "linear-gradient(to bottom right, rgba(34,52,97,0.25), rgba(11,10,31,0.05))",
                backdropFilter: "blur(50px)",
                WebkitBackdropFilter: "blur(50px)",
                maxHeight: "none",
                height: "auto",
              },
            }
            : {
              className: "bg-primary dark:bg-gray-900/50 rounded-3xl text-textPrimary"
            }}
        >
          {/* Analysis Report Dialog Box - Added Download Resume button */}
          <DialogTitle className="dark:text-[#8893C8] text-textPrimary text-sm flex justify-between items-center">
            <span>Analysis Report</span>

            <div className="flex items-center gap-2">
              {currentCandidate?.resume_s3_url ? (
                <button
                  className="flex items-center gap-2 hover:opacity-80 transition-opacity pr-10"
                  onClick={handleViewResume}
                >
                  <Download className="w-4 h-4 dark:text-[#C9A3FF] text-textSecondary" />
                  <span className="dark:text-[#C9A3FF] text-textSecondary font-normal text-sm">
                    Download Resume
                  </span>
                </button>
              ) : (
                <span className="dark:text-gray-500 text-textSecondary text-xs italic">No Resume</span>
              )}

              <IconButton
                onClick={closeModal}
                size="small"
                sx={{
                  color: "#8893C8",
                  "&:hover": { color: "white" },
                  padding: "4px", // Optional: tighter spacing
                }}
              >
                <CloseIcon fontSize="small" className="dark:text-white text-textSecondary" />
              </IconButton>
            </div>
          </DialogTitle>
          <style>{selectableStyles}</style>
          <DialogContent
            className=" dark:text-white text-textSecondary"
            sx={{ maxHeight: "none", overflow: "visible" }}
          >
            {currentReport && Object.keys(currentReport).length > 0 ? (
              <div className="w-full px-4 sm:px-0 pt-5">
                <div className="selectable-report rounded-3xl dark:shadow-xl shadow-sm  p-4 sm:p-6 border border-gray-700/50">
                  <div className="flex space-x-6">
                    <div className="h-36 w-36 relative">
                      <CircularProgressbar
                        value={
                          currentReport.score === null ||
                            currentReport.score === undefined ||
                            currentReport.score === "NA" ||
                            currentReport.score === "ERROR"
                            ? 0
                            : currentReport.score
                        }
                        text={
                          currentReport.score === null ||
                            currentReport.score === undefined ||
                            currentReport.score === "NA" ||
                            currentReport.score === "ERROR"
                            ? "NA"
                            : `${currentReport.score}%`
                        }
                        circleRatio={0.75}
                        styles={buildStyles({
                          rotation: 1 / 2 + 1 / 8,
                          strokeLinecap: "butt",
                          trailColor:
                            currentReport.score === null ||
                              currentReport.score === undefined ||
                              currentReport.score === "NA" ||
                              currentReport.score === "ERROR"
                              ? getScoreColorGradient(0)
                              : getScoreColorGradient(currentReport.score),
                          pathColor:
                            currentReport.score === null ||
                              currentReport.score === undefined ||
                              currentReport.score === "NA" ||
                              currentReport.score === "ERROR"
                              ? getPathColor(0)
                              : getPathColor(currentReport.score),
                          textColor: `${theme === 'dark' ? "#FFFFFF" : "#525252"}`,
                          textSize: "20px",
                        })}
                      />
                      <div
                        style={{
                          position: "absolute",
                          width: "100%",
                          textAlign: "center",
                          // color: "#FFFFFF99",
                          fontSize: "14px",
                          fontWeight: "normal",
                          bottom: "10px",
                        }}
                        className="dark:text-white text-textSecondary"
                      >
                        Score
                      </div>
                    </div>
                    <div className="flex-1 flex-col space-y-6 text-white pl-4">
                      <div className="flex-1 flex justify-between">
                        <div className="flex-1 flex flex-col border-r border-[#484474]">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Experience Match
                          </span>
                          <div className="text-[#D0D5EF] mt-2">
                            {Array.isArray(currentReport.experience_match) &&
                              currentReport.experience_match.length > 0 ? (
                              currentReport.experience_match.map(
                                (exp, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      color:
                                        exp.meets_requirement &&
                                          exp.meets_requirement.toLowerCase() ===
                                          "yes"
                                          ? "#34B53A"
                                          : "#DC0000",
                                    }}
                                  >
                                    {exp.candidate_experience}
                                  </span>
                                )
                              )
                            ) : (
                              <span className="dark:text-[#D0D5EF] text-textSecondary">
                                No experience data available
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="flex-1 flex flex-col border-r border-[#484474] pl-5">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Location
                          </span>
                          <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                            {currentReport.location_match &&
                              Object.keys(currentReport.location_match).length > 0
                              ? `${currentReport.location_match.candidate_location?.split(
                                ","
                              )[0] || "Not specified"
                              }`
                              : "No location data available"}
                          </span>
                        </div>
                        <div className="flex-1 flex flex-col pl-5">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Education
                          </span>
                          <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                            {currentReport.education_match &&
                              currentReport.education_match
                                .candidate_highest_education
                              ? currentReport.education_match
                                .candidate_highest_education
                              : "No education data available"}
                          </span>
                        </div>
                      </div>
                      <div className="mt-5 border-t border-[#484474]"></div>
                      <div className="flex-1 flex justify-between">
                        <div className="flex flex-col border-r border-[#484474] w-[32%]">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Red Flags
                          </span>
                          <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                            {Array.isArray(currentReport.red_flags) &&
                              currentReport.red_flags.length > 0
                              ? currentReport.red_flags.join(", ")
                              : "None"}
                          </span>
                        </div>
                        <div className="flex-1 flex flex-col border-[#484474] pl-5">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Tech/Tools Match
                          </span>
                          <div className="mt-2">
                            {Array.isArray(currentReport.tech_tool_match) &&
                              currentReport.tech_tool_match.length > 0 ? (
                              <div className="flex flex-wrap gap-3">
                                {currentReport.tech_tool_match
                                  .sort((a, b) => {
                                    const aStatus =
                                      a.skill_status?.toLowerCase() === "yes";
                                    const bStatus =
                                      b.skill_status?.toLowerCase() === "yes";
                                    if (aStatus && !bStatus) return -1;
                                    if (!aStatus && bStatus) return 1;
                                    return 0;
                                  })
                                  .map((skill, index) => (
                                    <SkillBadge
                                      key={index}
                                      skill={skill.skill_name}
                                      status={
                                        skill.skill_status?.toLowerCase() ===
                                          "yes"
                                          ? "yes"
                                          : "no"
                                      }
                                    />
                                  ))}
                              </div>
                            ) : (
                              <span className="dark:text-[#D0D5EF] text-textSecondary">
                                No tech/tools data available
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 border-t border-[#484474]">
                    <div className="flex justify-between mt-5">
                      <div className="flex-1 flex flex-col border-r border-[#484474] pr-5">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Highlights
                        </span>
                        <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                          {Array.isArray(currentReport.Strengths) &&
                            currentReport.Strengths.length > 0
                            ? currentReport.Strengths.map((point) =>
                              point.replace(/^- /, "").trim()
                            ).join(" ")
                            : "No highlights available"}
                        </span>
                      </div>
                      <div className="flex-1 flex flex-col border-[#484474] pl-5">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Lowlights
                        </span>
                        <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                          {Array.isArray(currentReport.Weaknesses) &&
                            currentReport.Weaknesses.length > 0
                            ? currentReport.Weaknesses.map((point) =>
                              point.replace(/^- /, "").trim()
                            ).join(" ")
                            : "No lowlights available"}
                        </span>
                      </div>
                    </div>
                    <div className="flex-1 flex flex-col mt-5 border-t border-[#484474]">
                      <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold mt-5">
                        Suggestions
                      </span>
                      <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                        {Array.isArray(currentReport.Suggestions) &&
                          currentReport.Suggestions.length > 0
                          ? currentReport.Suggestions.map((point) =>
                            point.replace(/^- /, "").trim()
                          ).join(" ")
                          : "No suggestions available"}
                      </span>
                    </div>
                    {/* ── NEW SECTION: Additional Information ── */}
                    {customAtsFormEnabled && (
                      <div className="mt-8 border-t border-[#484474] pt-6">
                        <h3 className="dark:text-[#8893C8] text-textSecondary text-base font-semibold mb-5">
                          Additional Information
                        </h3>

                        {/* ── NEW PAGINATED VERSION ── */}
                        {(() => {
                          const additionalInfoItems = [
                            { label: "Previous / Current Company", value: currentReport.current_employer },
                            { label: "Designation", value: currentReport.designation },
                            { label: "Year of Experience", value: currentReport.experience_years },
                            // { label: "Current Salary (CTC)", value: currentReport.current_ctc },
                            { label: "Expected Salary (CTC)", value: currentReport.expected_ctc },
                            // { label: "Notice Period", value: currentReport.notice_period },
                            { label: "Expected Joining Date", value: currentReport.expected_joining_date },
                            { label: "Visa Status", value: currentReport.visa_status },
                            { label: "Languages Known", value: currentReport.languages_known },
                            { label: "Years In College", value: currentReport.college_years },
                            { label: "Relatives In Company", value: currentReport.relatives_in_company },
                            { label: "Current Benefits", value: currentReport.current_benefits },
                            // { label: "Gender", value: currentReport.gender },
                            { label: "Marital Status", value: currentReport.marital_status },
                            { label: "Source", 
                              value: currentReport.other_source_details === "NA" 
                                ? currentReport.source_of_application 
                                : currentReport.other_source_details 
                            },
                          ];

                          // Filter out items with no real value
                          const visibleItems = additionalInfoItems.filter(item =>
                            item.value &&
                            item.value !== "NA" &&
                            item.value.trim() !== "" &&
                            item.value !== "N/A" &&
                            item.value !== null &&
                            item.value !== undefined
                          );

                          if (visibleItems.length === 0) {
                            return null; // don't show the whole section
                            // Alternative: return <p className="text-gray-500 italic">No additional information provided</p>
                          }

                          const itemsPerPage = 6;
                          const totalPages = Math.ceil(visibleItems.length / itemsPerPage);
                          const startIdx = additionalInfoPage * itemsPerPage;
                          const currentPageItems = visibleItems.slice(startIdx, startIdx + itemsPerPage);

                          return (
                            <div className="relative">
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 px-12">
                                {currentPageItems.map((item, index) => {
                                  const isLastInRowLg = index % 3 === 2 || index === currentPageItems.length - 1;
                                  const isLastInRowMd = index % 2 === 1 || index === currentPageItems.length - 1;

                                  return (
                                    <div
                                      key={index}
                                      className={`
                                        ${!isLastInRowMd ? "md:border-r md:border-[#484474] md:pr-8" : ""}
                                        ${index % 2 === 1 ? "md:pl-8" : ""}
                                        ${!isLastInRowLg ? "lg:border-r lg:border-[#484474] lg:pr-8" : "lg:border-r-0 lg:pr-0"}
                                        ${index % 3 !== 0 ? "lg:pl-8" : "lg:pl-0"}
                                      `}
                                    >
                                      <div className="text-sm text-gray-400 dark:text-gray-500 mb-1">
                                        {item.label}
                                      </div>
                                      <div className="dark:text-[#D0D5EF] text-textSecondary font-medium">
                                        {item.value || "NA"}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>

                              {totalPages > 1 && (
                                <>
                                  <button
                                    onClick={() => setAdditionalInfoPage(prev => Math.max(0, prev - 1))}
                                    disabled={additionalInfoPage === 0}
                                    className="absolute left-0 top-1/2 -translate-y-1/2 p-2 rounded-full hover:bg-gray-700/50 disabled:opacity-0 disabled:cursor-not-allowed transition-all"
                                    title="Previous page"
                                  >
                                    <ChevronLeft className="w-6 h-6 dark:text-[#C9A3FF] text-indigo-400" />
                                  </button>

                                  <button
                                    onClick={() => setAdditionalInfoPage(prev => Math.min(totalPages - 1, prev + 1))}
                                    disabled={additionalInfoPage === totalPages - 1}
                                    className="absolute right-0 top-1/2 -translate-y-1/2 p-2 rounded-full hover:bg-gray-700/50 disabled:opacity-0 disabled:cursor-not-allowed transition-all"
                                    title="Next page"
                                  >
                                    <ChevronRight className="w-6 h-6 dark:text-[#C9A3FF] text-indigo-400" />
                                  </button>
                                </>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <p className="dark:text-[#D0D5EF] text-textSecondary">No report available</p>
            )}
            {currentCandidate && (
              <div className="flex justify-end gap-3 mt-6 px-2 pb-2">
                <button
                  className={theme === 'dark' ? 'button text-sm hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed' : "border-btn hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"}
                  onClick={() => {
                    closeModal(); // Close the analysis report modal
                  }}
                >
                  <span className="dark:text-white text-textSecondary">Close</span>
                </button>
                <button
                  className="px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm button hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={() => {
                    setSelectedCandidates([currentCandidate]);
                    setIsSchedulePopup(true);
                    closeModal(); // Close the analysis report modal
                  }}
                  disabled={
                    currentCandidate?.interview_id &&
                    currentCandidate?.status === "scheduled"
                  }
                >
                  <span className="text-white">Schedule Interview</span>
                </button>
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <ConfirmationDialog
          open={isDeletePopup}
          onClose={() => setIsDeletePopup(false)}
          title="Delete Candidates"
          message={`Are you sure you want to delete ${selectedCandidates.length
            } selected candidate${selectedCandidates.length > 1 ? "s" : ""}?`}
          confirmText="Delete"
          cancelText="Cancel"
          onConfirm={deleteSelectedCandidates}
        />

        {/* Schedule Interview Dialog */}
        <Dialog
          open={isSchedulePopup}
          onClose={() => setIsSchedulePopup(false)}
          PaperProps={{
            sx: {
              background:
                `${theme === 'dark' ? "linear-gradient(to bottom right, rgba(34,52,97,0.25), rgba(11,10,31,0.05))" : ""}`,
              backdropFilter: "blur(50px)",
              WebkitBackdropFilter: "blur(50px)",
              borderRadius: "12px",
              padding: "10px",
              maxWidth: "600px",
              width: "100%",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              transition: "none !important",
            },
          }}
          TransitionProps={{
            timeout: 0,
          }}
        >
          <DialogTitle
            sx={{
              fontFamily: "Poppins",
              color: `${theme === 'dark' ? 'white' : "#525252"}`,
              fontSize: "1.10rem",
              fontWeight: 400,
              position: 'relative',
              pr: 6,
            }}
          >
            Schedule Interview
            <IconButton
              aria-label="close"
              onClick={() => setIsSchedulePopup(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                color: theme === 'dark' ? 'white' : '#525252',
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                alignItems: "left",
              }}
            >
              <div className={`platform-calendar ${theme}`}>
                <PlatformCalendar
                  onChange={(value) => setDateRange(value)}
                  value={dateRange}
                  selectRange={true}
                  minDate={new Date()}
                />
              </div>
            </Box>
          </DialogContent>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", p: 1, gap: 1 }}
          >
            <Button
              onClick={() => {
                setDateRange([null, null]);
              }}
              sx={{
                textTransform: "none",
                fontFamily: "Poppins",
                fontWeight: 300,
                // color: "white",
              }}
              className={`${theme === 'dark'
                ? 'border border-gray-600 !text-gray-300'
                : 'border-btn !text-textSecondary'
                }`}
            >
              Clear
            </Button>
            <Button
              variant="contained"
              onClick={scheduleInterviewForAll}
              disabled={!dateRange[0] || !dateRange[1]}
              sx={{
                textTransform:"none",
                fontFamily: "Poppins",
                fontWeight: 300,
                background: "linear-gradient(to left, #FB54AE, #2F64FF)",
                color: "white",
                borderRadius: "9999px",
                "&.Mui-disabled": {
                  background: "linear-gradient(to left, #FB54AE, #2F64FF)",
                  opacity: 0.6,
                  color: "white",
                },
              }}
            >
              Schedule
            </Button>
          </Box>
        </Dialog>
      </div>
    </div>
  );
};

export default SourcedCandidates;
